window.ProfilePageIntroductionConditionsInformer = {
	areConditionsMet() {
		return !this.elementSeenBefore();
	},

	triggerAfterYoloRegistration(callback) {
		if (!this.areConditionsMet()) {
			return;
		}

		document.addEventListener(
			'student-registered',
			(e) => {
				if (e.detail === undefined || e.detail.provider !== 'Google') {
					return;
				}

				callback();
			},
			{
				once: true
			}
		);
	},

	elementSeenBefore() {
		if (!window.Loot || !window.Loot.DataStorage) {
			console.warn('Loot has not initialized');
			return false;
		}
		return Loot.DataStorage.retrieve('ProfilePageIntroductionShown') === true;
	}
};
